// Chargebee formats param validation errors as "billing_address[zip] : message" or, for the
// top-level vat_number param, "vat_number : message". Pull out the param name and message so
// the caller can map it to a form field.
export function parseChargebeeFieldError(
  message?: string,
): { field: string; message: string } | undefined {
  const match = message?.match(/(?:billing_address\[(\w+)\]|(vat_number)) : (.*)/);
  if (!match) return undefined;

  return { field: match[1] ?? match[2], message: match[3] };
}
